import FieldConfig from "../../../../proto/field-config"
import FieldDate from "../../../../generic/datetime/date/date"
import ItemModelV2 from "../../../../../model2/item2/item-model"
import TasksViewManager from "../../../../../gd-modules/tasks-view/core/manager"
import Project from "../../../../../model2/project/project"
import GanttManager from "../../../../../gd-modules/gantt-chart/manager/manager"
import {ViewType} from "../../../../../gd/const/views/view-type"
import FieldProjectEndDate_Popover from "./components/popover/popover"
import FieldProto_updateView from "../../../../proto/render/table/function/update-view"

export default class FieldProjectEndDate extends FieldDate {

    constructor(config:FieldConfig) {
        super(config);

        this.icon               = 'i5-date-end'
        this.label              = 'End date'

        this.minDate            = moment()


        this.fieldParams.highlightIfPastdue         = false

        this.components.PopoverMenu                 = FieldProjectEndDate_Popover

        // this.renderComponents.tableCell     = FieldProto_TableCellReadOnly
        this.fieldParams.tableCellOnValueChange = this.tableCellOnValueChange
    }


    // ACCESS
    canEdit(model:Project):boolean {
        return model.acl.canChangeEndDate
    }

    // Custom Methods

    tableCellOnValueChange = (item: ItemModelV2, value:any, manager:TasksViewManager|GanttManager) => {
        switch (manager.module) {
            case ViewType.PROJECT_GANTT:
            case ViewType.PORTFOLIO_GANTT:
            case ViewType.CUSTOM_VIEW_GANTT:

                const newStartDate = item.project.startDate ? item.project.startDate : value
                const newEndDate = value

                const ganttManager = manager as GanttManager
                ganttManager.setStartEnd(item.id, newStartDate, newEndDate)

                break

            default:
                item.project.updateEndDate(value)
                item.project.save()

                item.updateLastUpdateTime() // otherwise it wont re-render

                FieldProto_updateView(manager as TasksViewManager, this)
                break
        }
    }

}
